import React, { useState, useEffect } from "react";
import { TextField, Autocomplete } from "@mui/material";
import AxiosInstance from "../../utils/Axios.ts";

interface Agent {
  id: number;
  name: string;
}

interface AgentInputProps {
  value: number | null;
  onChange: (value: number) => void;
  label?: string;
  size?: "small" | "medium";
}

const AgentInput: React.FC<AgentInputProps> = ({ value, onChange, label = "Agent", size = "medium" }) => {
  const [options, setOptions] = useState<Agent[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchAgents = async (query: string) => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams({ search: query });
      const response = await AxiosInstance.get(`/agent/?${params.toString()}`);

      if (response.status === 200) {
        setOptions(response.data.results || []);
      }
    } catch (error) {
      console.error("Error fetching agents:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAgents(""); // Initial fetch with no query
  }, []);

  const handleInputChange = (event: React.ChangeEvent<{}>, newInputValue: string) => {
    fetchAgents(newInputValue);
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: Agent | null) => {
    if (newValue) {
      onChange(newValue.id);
    } else {
      onChange(0);
    }
  };

  return (
    <Autocomplete
      size={size}
      options={options}
      getOptionLabel={(option) => option.name}
      value={options.find((opt) => opt.id === value) || null}
      onInputChange={handleInputChange}
      onChange={handleChange}
      loading={isLoading}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" fullWidth size={size} />
      )}
    />
  );
};

export default AgentInput;
